import React from 'react'

export const VoiceUpdateTag = () => {
  return (
    <span
      className="font-bold text-white text-[11px] px-2 py-[6px] rounded-[4px] text-center"
      style={{
        background: `linear-gradient(to right,#6095FF,#D512E7)`,
      }}
    >
      {`🎉️ ‘내 목소리 만들기’ UPDATE!`}
    </span>
  )
}
